import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FeedbackApi } from '../feedback-api';
import type { FeedbackData } from '../../types';

@injectable()
export class FeedbackApiImpl extends PsHttpService implements FeedbackApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    feedbackPost<T>(data: FeedbackData<T>) {
        return this.post<PatSnapCommonResponseData<boolean>>({
            url: '/air/feedback',
            data,
        }).then((res) => {
            return res.status as boolean
        })
    }
}
